/* eslint-disable @typescript-eslint/consistent-type-definitions */

export interface ElementSizes {
  circleImage: string;
  horizontalImageWidth: string;
  horizontalImageHeight: string;
  portraitImageWidth: string;
  portraitImageHeight: string;
  squareImageWidth: string;
  squareImageHeight: string;
  bannerImageWidth: string;
  bannerImageHeight: string;
  smallImageWidth: string;
  smallImageHeight: string;
  largeImageWidth: string;
  largeImageHeight: string;
  iconWidth: string;
  iconHeight: string;
  logoWidth: string;
  logoHeight: string;
  videoWidth: string;
  videoHeight: string;
  mapSize: string;
  containerWidth: string;
  containerHeight: string;
  titleFontSize: string;
  descriptionXxsmallFontSize: string;
  descriptionXsmallFontSize: string;
  descriptionLargeFontSize: string;
  descriptionMediumFontSize: string;
  descriptionSmallFontSize: string;
  menuButtonWidth: string;
  menuButtonHeight: string;
  inputWidth: string;
  inputHeight: string;
  formButtonPadding: string;
  cardContainerWidth: string;
  cardContainerHeight: string;
  [key: string]: string;
}

export interface Fonts {
  rubikBoldItalic: string;
  rubikExtraBold: string;
}

export interface Theme {
  primaryColor: string;
  hoverColor: string;
  backgroundColor: string;
  menuColor: string;
  menuGradient?: string;
  textColor: string;
  gradientColors: [string, string];
  borderColor: string;
  shadowDarkColor: string;
  shadowLightColor: string;
  titleColor: string;
  descriptionColor: string;
  descriptionBackgroundColor: string;
  iconColor: string;
  MenuItemSelectedColor: string;
  circleTextColor: string;
  themeSelectColor: string;
  titleGradientColors?: [string, string, string?]; 
  titleGradientAngle?: string;
  titleStrokeColor?: string;  
  sizes: {
    small: ElementSizes;
    medium: ElementSizes;
    large: ElementSizes;
  };
  fonts: Fonts;
}

const sizes: Theme['sizes'] = {
  small: {
    circleImage: '180px',
    horizontalImageWidth: '250px',
    horizontalImageHeight: '300px',
    portraitImageWidth: '200px',
    portraitImageHeight: '300px',
    squareImageWidth: '280px',
    squareImageHeight: '280px',
    bannerImageWidth: '90vw',
    bannerImageHeight: '200px',
    smallImageWidth: '60px',
    smallImageHeight: '60px',
    largeImageWidth: '70vw',
    largeImageHeight: '70vh',
    iconWidth: '25px',
    iconHeight: '25px',
    logoWidth: '200px',
    logoHeight: '30px',
    videoWidth: '100%',
    videoHeight: '100%',
    mapSize: '200px',
    containerWidth: '90%',
    containerHeight: '100%',
    titleFontSize: '27px',
    descriptionXxsmallFontSize: '13px',
    descriptionXsmallFontSize:  '16px',
    descriptionLargeFontSize:   '22px',
    descriptionMediumFontSize:  '13px', 
    descriptionSmallFontSize:   '15px',
    menuButtonWidth: '100px',
    menuButtonHeight: '40px',
    inputWidth: '70%',
    inputHeight: '8px',
    formButtonPadding: '5px 20px',
    cardContainerWidth: '300px',
    cardContainerHeight: '600px',
  },

  medium: {
    circleImage: '400px',
    horizontalImageWidth: '300px',
    horizontalImageHeight: '300px',
    portraitImageWidth: '250px',
    portraitImageHeight: '350px',
    squareImageWidth: '320px',
    squareImageHeight: '320px',
    bannerImageWidth: '85vw',
    bannerImageHeight: '250px',
    smallImageWidth: '75px',
    smallImageHeight: '75px',
    largeImageWidth: '35vw',
    largeImageHeight: '65vh',
    iconWidth: '30px',
    iconHeight: '30px',
    logoWidth: '200px',
    logoHeight: '30px',
    videoWidth: '80vw',
    videoHeight: '80vh',
    mapSize: '200px',
    containerWidth: '85%',
    containerHeight: '100%',
    titleFontSize: '40px',
    descriptionXxsmallFontSize: '16px',
    descriptionXsmallFontSize:  '18px',
    descriptionLargeFontSize:   '25px',
    descriptionMediumFontSize:  '22px',
    descriptionSmallFontSize:   '20px',
    menuButtonWidth: '80px',
    menuButtonHeight: '40px',
    inputWidth: '70%',
    inputHeight: '10px',
    formButtonPadding: '10px 30px',
    cardContainerWidth: '500px',
    cardContainerHeight: '500px',
  },

  large: {
    circleImage: '600px',
    horizontalImageWidth: '400px',
    horizontalImageHeight: '500px',
    portraitImageWidth: '250px',
    portraitImageHeight: '550px',
    squareImageWidth: '360px',
    squareImageHeight: '360px',
    bannerImageWidth: '70vw',
    bannerImageHeight: '280px',
    smallImageWidth: '120px',
    smallImageHeight: '120px',
    largeImageWidth: '25vw',
    largeImageHeight: '60vh',
    iconWidth: '30px',
    iconHeight: '30px',
    logoWidth: '200px',
    logoHeight: '30px',
    videoWidth: '60vw',
    videoHeight: '60vh',
    mapSize: '200px',
    containerWidth: '65%',
    containerHeight: '100%',
    titleFontSize: '50px',
    descriptionXxsmallFontSize: '18px',
    descriptionXsmallFontSize:  '20px',
    descriptionLargeFontSize:   '23px',
    descriptionMediumFontSize:  '22px',
    descriptionSmallFontSize:   '21px',
    menuButtonWidth: '110px',
    menuButtonHeight: '40px',
    inputWidth: '70%',
    inputHeight: '12px',
    formButtonPadding: '10px 40px',
    cardContainerWidth: '600px',
    cardContainerHeight: '600px',
  },
};

export interface Fonts {
  rubikBoldItalic: string;
  rubikExtraBold: string;
}

const fonts: Fonts = {
  rubikBoldItalic: 'Rubik-BoldItalic',
  rubikExtraBold: 'Rubik-ExtraBold',
};

export const darkTheme: Theme = {
  primaryColor: 'rgb(15, 15, 15)',
  hoverColor: '#ffffff',
  backgroundColor: '#000000',
  menuColor: 'rgb(0, 0, 0)',
  menuGradient: 'linear-gradient(90deg, #0d0d0d 0%, #2e003e 50%, #0d0d0d 100%)',
  textColor: '#ffffff',
  gradientColors: ['rgb(65, 118, 204)', 'rgb(182, 72, 182)'],
  borderColor: '#f8f8f8',
  shadowDarkColor: '#000000',
  shadowLightColor: 'rgb(255, 255, 255)',
  titleColor: 'rgb(130, 48, 160)',
  descriptionColor: 'rgb(255, 255, 255)',
  descriptionBackgroundColor: 'rgba(52, 36, 36, 0.56)',
  iconColor: '#000000',
  MenuItemSelectedColor: '#8943a9',
  circleTextColor: 'rgb(135, 49, 169)',
  themeSelectColor: '#ffffff',
  titleGradientColors: ['#e879f9', '#60a5fa', '#22d3ee'], 
  titleGradientAngle: '135deg',
  titleStrokeColor: 'rgba(0,0,0,0.6)', 
  sizes,
  fonts,
};

export const lightTheme: Theme = {
  primaryColor: '#6a1b9a',
  hoverColor: '#2979FF',
  backgroundColor: '#ffffff',
  menuColor: '#E0E0E0',
  menuGradient: 'linear-gradient(90deg, #f8e1ff 0%, #6a1b9a 50%, #f8e1ff 100%)',
  textColor: '#333333',
  gradientColors: ['rgb(65, 118, 204)', 'rgb(182, 72, 182)'],
  borderColor: '#000000',
  shadowDarkColor: '#f8f8f8',
  shadowLightColor: '#000000',
  titleColor: 'rgb(192, 76, 213)',
  descriptionColor: '#000000',
  descriptionBackgroundColor: 'rgba(255,255,255,0.3)',
  iconColor: '#000000',
  MenuItemSelectedColor: '#a24fc8',
  circleTextColor: '#b341c4',
  themeSelectColor: '#000000',
  titleGradientColors: ['#7c3aed', '#e879f9', '#22d3ee'],
  titleGradientAngle: '135deg',
  titleStrokeColor: 'rgba(255,255,255,0.85)',
  sizes,
  fonts,
};
